// When the employee is still filling the forms :
export const Created = {
  key: 'CREATED',
  beneficiaryWelcomePageRecordLabel: (isActive) => isActive ? 'À terminer' : '',
  managerReportLabel: 'À terminer'
};

// When the employee has filled all forms and submitted the file to his manager :
export const Sent = {
  key: 'SENT',
  beneficiaryWelcomePageRecordLabel: () => 'En attente de validation',
  managerReportLabel: 'En attente de validation'
};

// When the manager has rejected the employee file (cannot be edited anymore by the employee) :
export const Refused = {
  key: 'REFUSED',
  beneficiaryWelcomePageRecordLabel: () => 'Refusé',
  managerReportLabel: 'Refusé'
};

// When the manager has validated the employee file :
export const Validated = {
  key: 'VALIDATED',
  beneficiaryWelcomePageRecordLabel: (isActive) => isActive ? 'Je déclare' : 'Fin de droit' ,
  managerRecordDetails: 'Ouvert',
  managerReportLabel: 'Ouvert'
};

// When the manager has closed a validated file that is no longer active :
export const Archived = {
  key: 'ARCHIVED',
  beneficiaryWelcomePageRecordLabel: () => 'Archivé',
  managerRecordDetails: 'Archivé',
  managerReportLabel: 'Archivé'
};

export const RecordStatuses = {
  CREATED: Created,
  SENT: Sent,
  REFUSED: Refused,
  VALIDATED: Validated,
  ARCHIVED: Archived
};

export function getStatusFrom(record) {
  const statusKey = record.status
  const status = RecordStatuses[statusKey]
  return status || {}
}

export function isCreated(record) {
  return record.status === Created.key
}

export function isSent(record) {
  return record.status === Sent.key
}

export function isArchived(record) {
  return record.status === Archived.key
}

export function isValidated(record) {
  return record.status === Validated.key
}

export function isNotValidated(record){
  return record.status !== Validated.key
}

export function isActive(record) {
  const inactiveStatus = [Archived.key, Refused.key]
  return !inactiveStatus.includes(record.status)
}
